import type { InputHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

type Props = InputHTMLAttributes<HTMLInputElement>;

/** Text field using shell border/surface tokens. */
export function Input({ className, ...rest }: Props) {
  return (
    <input
      className={cn(
        'w-full rounded-xl border border-[var(--border)] bg-[var(--card)] px-3 py-2 text-sm text-[var(--foreground)] placeholder:text-[var(--muted)] focus:outline-none focus:ring-2 focus:ring-[var(--ring)]',
        className,
      )}
      {...rest}
    />
  );
}
